var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCartEm = function SvgCartEm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none",
    viewBox: "0 0 46 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.652 41.208h-16c-5.877 0-10.386-2.123-9.105-10.667l1.491-11.579c.79-4.263 3.509-5.895 5.895-5.895h19.509c2.42 0 4.982 1.755 5.895 5.895l1.49 11.58c1.088 7.578-3.297 10.666-9.175 10.666",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.915 12.647a8.28 8.28 0 0 0-8.28-8.28v0a8.28 8.28 0 0 0-8.317 8.28h0M29.32 21.279h-.088M18.144 21.279h-.088"
  })));
};
export default SvgCartEm;